var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDfeeas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.899902,
    width: 27,
    height: 27,
    rx: 8,
    fill: "#002C62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.4647C6.75 9.03179 6.90203 8.67465 7.20608 8.39327C7.51013 8.11188 7.90541 7.97119 8.39189 7.97119C8.8697 7.97119 9.25627 8.10971 9.55164 8.38678C9.85569 8.67249 10.0077 9.04478 10.0077 9.50366C10.0077 9.91924 9.86004 10.2656 9.56467 10.5426C9.26062 10.8283 8.861 10.9712 8.36583 10.9712H8.3528C7.875 10.9712 7.48842 10.8283 7.19305 10.5426C6.89768 10.2569 6.75 9.89759 6.75 9.4647ZM6.9194 20.8283V12.153H9.81226V20.8283H6.9194ZM11.4151 20.8283H14.3079V15.9842C14.3079 15.6811 14.3427 15.4474 14.4122 15.2829C14.5338 14.9885 14.7184 14.7396 14.966 14.5361C15.2136 14.3327 15.5241 14.2309 15.8977 14.2309C16.8707 14.2309 17.3571 14.8846 17.3571 16.192V20.8283H20.25V15.8543C20.25 14.5729 19.946 13.6011 19.3378 12.9387C18.7297 12.2764 17.9262 11.9452 16.9271 11.9452C15.8065 11.9452 14.9334 12.4257 14.3079 13.3868V13.4127H14.2949L14.3079 13.3868V12.153H11.4151C11.4324 12.4301 11.4411 13.2915 11.4411 14.7374C11.4411 16.1833 11.4324 18.2136 11.4151 20.8283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfeeas);
export default __webpack_public_path__ + "static/media/dfeeas.665570341135a9639062e70e9675ea77.svg";
export { ForwardRef as ReactComponent };